import { mapGetters, mapActions } from "vuex";
import {
  isEmpty as _isEmpty,
  difference as _difference,
  capitalize as _capitalize,
  keys as _keys,
  forEach as _forEach,
  get as _get,
  escapeRegExp as _escapeRegExp
} from "lodash";
import moment from "moment";

let Vue = require('vue');

if ( typeof Vue.compile === 'undefined') {
    // Force Jest to load the full version of Vue with compiler
    Vue = require('vuetest');
}

export default {
    created() {
        this.template = Vue.compile(window.P2A.campaignSettings.templates[this.$options.name]).render;
    },
    data() {
      return {
        mobileBreakpoint: 768,
        twitterWebIntentUrl: "https://twitter.com/intent/tweet",
        tabSuffix: 'tab',
        panelSuffix: 'panel'
      }
    },
    computed: {
      ...mapGetters({
        actionDetails: "navigation/actionDetails",
        actionError: "forms/actionError",
        advocateLastName: "advocate/lastName",
        advocateSubmittedInfo: "forms/advocateRecord",
        formValues: "forms/formValues",
        getModalState: "navigation/modalOpen",
        stepModalOpen: "navigation/stepModalOpen",
        cancelSources: "api/cancelSources",
        campaignRestrictionsError: "navigation/campaignRestrictionsError",
        completedAllActions: "navigation/completedAllActions",
        legislatorsErrorMessage: "legislators/errorMessage",
        legislatorResults: "legislators/legislatorResults",
        tweetsPosted: "legislators/tweetsPosted"
      }),
      advocateFirstName() {
        return this.$store.getters["advocate/firstName"] || this.formFirstName;
      },
      advocateLastName() {
          return this.$store.getters["advocate/lastName"] || this.formLastName;
      },
      actionGeosearchComplete() {
        return true;
        // ToDo: Check if we still need this check for convo campaigns with SDG groups (PDEV 7775)
        // return (
        //   !_isEmpty(this.legislatorResults[this.currentAction]) ||
        //   this.geosearchErrorExists
        // );
      },
      currentAction() {
        return this.$store.getters["navigation/activeAction"];
      },
      currentStep() {
        return this.$store.getters["navigation/activeStep"];
      },
      currentActiveTabID() {
        return `${this.currentAction}-${this.tabSuffix}`
      },
      currentActivePanelID() {
        return `${this.currentAction}-${this.panelSuffix}`
      },
      numberOfIncompletedActions() {
        return _difference(this.enabledActions, this.completedActions).length;
      },
      completedActions() {
        let completed = [];
        _forEach(this.actionDetails, (details, action) => {
          if (details.completed || details.skipped) {
            completed.push(action);
          }
        });
        return completed;
      },
      currentActionCard() {
        if (this.completedAllActions) {
          return "thankyou";
        } else if (this.isActionCard("email")) {
          return "sendemail";
        } else if (this.isActionCard("twitter")) {
          return "twitter";
        } else if (this.isActionCard("call")) {
          return "call";
        }

        return null;
      },
      enabledActions() {
        return _keys(this.actionDetails);
      },
      errorModalOpen() {
        return this.stepModalOpen === 'error'
      },
      expandedLegislatorLists() {
        return this.$store.getters[`legislators/expandedLegislatorLists`];
      },
      fieldsetKey() {
        return `${this.currentStep}-${this.currentAction}`;
      },
      formFirstName() {
        const firstName = _get(this, 'formValues.firstName');
        if(firstName){
          return _capitalize(firstName);
        }

        return this.formValues.fullName
          ? _capitalize(this.formValues.fullName.split(" ")[0])
          : "";
      },
      formLastName() {
        const lastName = _get(this, 'formValues.lastName');
        if(lastName){
          return _capitalize(lastName);
        }

        const nameComponents = this.formValues.fullName || "";
        if (nameComponents.split(" ").length > 1) {
          return _capitalize(nameComponents.split(" ").splice(-1)[0]);
        }
        return "";
      },
      geosearchErrorExists() {
        return (
          (this.campaignRestrictionsError === true) ||
          !_isEmpty(this.legislatorsErrorMessage)
        );
      },
      hideBackgroundElements() {
        return this.isMobile || _isEmpty(this.expandedLegislatorLists);
      },
      isMultiMessage() {
        const legislatorMessages = this.legislatorResults[this.currentAction] || [];
        return Object.keys(legislatorMessages).length > 1;
      },
      isStepModalOpen() {
        return this.stepModalOpen !== "";
      },
      legislatorsPulled() {
        return this.$store.getters["legislators/legislatorsPulled"];
      },
      mergeVariables() {
        const advocateStatePhone = this.formValues.phone;
        const advPhone = this.formatPhone(advocateStatePhone);
        const advCity = this.formValues.city || "";
        const advState = this.formValues.state || "";
        const transformedCustomFieldsData = this.transformedCustomFieldsData(this.advocateSubmittedInfo.customFields);
        const advocateFullAddress = () => {
          let address = '';

          if (this.formValues.city && this.formValues.state) {
            if (this.formValues.address1) {
              address += this.formValues.address1;
            }
            if (this.formValues.address2) {
              address += `<br/>${this.formValues.address2}`;
            }

            address += `<br/>${advCity}, ${advState}`

            if (this.formValues.zip5) {
              address += ` ${this.formValues.zip5}`;
            }
          }

          return address;
        }

        return {
          advAddress: this.formValues.address1 || "",
          advEmail: this.formValues.email || "",
          advFirst: this.advocateFirstName || "",
          advLast: this.advocateLastName || "",
          advZip5: this.formValues.zip5 || "",
          advPhone,
          advCity,
          advState,
          advFullAddress: advocateFullAddress(),
          ...transformedCustomFieldsData
        };
      },
      shortDate() {
        return moment().format("MMM D");
      },
      watchActionAndLegislators() {
        return [this.$store.getters["navigation/activeAction"], this.$store.getters["legislators/legislatorsPulled"]].join("");
      },
      currentActionTaken() {
        return this.$store.getters["navigation/currentActionTaken"];
      }
    },
    methods: {
      ...mapActions({
        closeStepModal: "navigation/stepModalOpen", // call with no args
        setModalState: "navigation/modalOpen",
        setStepModalOpen: "navigation/stepModalOpen",
        setTweetsPosted: "legislators/tweetsPosted"
      }),
      getTabID(tabName) {
        return `${tabName}-${this.tabSuffix}`
      },
      getPanelID(panelName) {
        return `${panelName}-${this.panelSuffix}`
      },
      showErrorModal() {
        this.setStepModalOpen("error");
      },
      setCampaignRestrictionError(error) {
        const restricted = this.axiosHelper.isCampaignRestricted(error);

        this.$store.dispatch("navigation/campaignRestrictionsError", restricted);

        if (restricted) {
          this.showErrorModal();
        }

        return restricted;
      },
      extractGoogleAutocompleteAddress(addressComponents) {

        let extractedComponents = [];

        addressComponents.forEach((addressComponent) => {
          extractedComponents[addressComponent.types[0]] = addressComponent.short_name;
        });

        return extractedComponents;
      },
      formatPhone(phone) {
        // https://gist.github.com/kkiernan/7475b615485344f2fdf3
        if(!phone || !phone.length){
            return "";
        }
        if (phone.charAt(0) === '1') {
          phone = phone.substring(1);
        } else if (phone.charAt(0) === '+' && phone.charAt(1) === '1') {
          phone = phone.substring(2);
        }
        return phone.replace(/[^0-9]/g, '')
          .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
      },
      getAdvocateAddress(formValues) {
        const keys = [
          'state',
          'city',
          'county',
          'zip4',
          'lat',
          'lon'
        ];
        let advocateAddress = {
          address1: formValues.address1,
          zip5: formValues.zip5,
          // honeypot values
          zipcode: formValues.zipcode,
          address: formValues.address
        };

        keys.forEach(key => {
          if (formValues[key]) {
            advocateAddress[key] = formValues[key];
          }
        });

        if (!_isEmpty(formValues.country)) {
          advocateAddress = {
            ...advocateAddress,
            country: formValues.country
          };
        }

        return advocateAddress;
      },
      interpretPhoneNumber(phoneNumber) {
        if(phoneNumber && phoneNumber.length > 10 && phoneNumber.indexOf("+") === 0) {
            phoneNumber = phoneNumber.substr(2);
        }

        return phoneNumber;
      },
      isActionCard(action) {
        return this.currentAction === action && this.legislatorsPulled && !this.completedAllActions;
      },
      normalizePhone(phone) {
        if (!phone) {
          return '';
        }

        const digitParts = phone.match(/\d+/g);
        return digitParts ? digitParts.join('') : '';
      },
      isTruthy(value){
        const stringValue = value && ((value).toString().toLowerCase());
        return stringValue === 'true' || stringValue === '1';
      },
      openPopup(url, opts) {
        opts = opts || {};

        const width = opts.width || 800;
        const height = opts.height || 600;
        const left = parseInt((window.width - width) / 2);
        const top = parseInt((window.height - height) / 3);
        const windowName = opts.windowName || 'window-' + Math.random(1000);

        return window.open(url, `window-${windowName}`, `menubar=0,location=0,status=0,width=${width},height=${height},resizable=1,left=${left},top=${top}`);
      },
      openTab(url) {
        return window.open(url, '_blank').focus();
      },
      openWebIntent(message, media) {
        return this.openTab(
          `${this.twitterWebIntentUrl}?text=${encodeURIComponent(message)}${media || ''}`
        );
      },
      populateMergeVariables(message, variables) {
        if(!message) {
          return message;
        }
        for(const key in variables) {
          let variable = variables[key];
          if (!isNaN(key)) {
            let keyRegex = new RegExp(_escapeRegExp(`[@customField?${key}]`), 'g');
            message = message.replace(keyRegex, variable || '');
          } else {
            let keyRegex = new RegExp(_escapeRegExp(`[@${key}]`), 'g');
            message = message.replace(keyRegex, variable || '');
          }
        }
        return message;
      },

      // transform custom fields into an object with the format `label: response`
      transformedCustomFieldsData(rawCustomFieldsData) {
        const transformedCustomFieldsData = {};

        for (const key in rawCustomFieldsData) {
          const { id, prompt, value, inputtype } = rawCustomFieldsData[key];
          const isCheckbox = inputtype === "CHECKBOX" && value && value.length;

          // Checkboxes have the format 'option one' or '["option one",  "option two"]' based on the number of options selected
          let clonedValue;
          try {
            clonedValue = isCheckbox ? JSON.parse(value).join(" ") : value;
          } catch(err) {
            clonedValue = value;
          }
          

          transformedCustomFieldsData[prompt] = clonedValue;
          transformedCustomFieldsData[id] = clonedValue;
        }

        return transformedCustomFieldsData;
      },
    },
    render: function(createElement) {
        if (!this.template) {
            return createElement('div', 'Loading...');
        } else {
            return this.template();
        }
    },
};
